import React from 'react';
import { Package, DollarSign, MapPin, Headphones, Shield, Clock } from 'lucide-react';
import { benefits } from '../data/mock';

const BenefitsSection = () => {
  const iconMap = {
    Package: Package,
    DollarSign: DollarSign,
    MapPin: MapPin,
    Headphones: Headphones,
    Shield: Shield,
    Clock: Clock
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--sendhapy-teal)' }}>
            ¿Por qué elegirnos?
          </h2>
          <p className="text-xl text-gray-600">
            Somos tu mejor opción para envíos entre Miami y Costa Rica
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {benefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            
            return (
              <div key={benefit.id} className="sendhapy-card">
                <div className="sendhapy-card-icon">
                  <IconComponent size={28} />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--sendhapy-teal)' }}>
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bloque de marca con foto oficial */}
        <div className="grid grid-cols-1 md:grid-cols-2 items-center rounded-3xl overflow-hidden" style={{ background: 'var(--sendhapy-teal)' }} data-testid="benefits-brand-block">
          <img
            src="/images/sendhapy-bolsa.jpg"
            alt="Bolsa verde y amarilla con la marca SendHapy"
            className="w-full h-auto block"
            width="1149"
            height="932"
            loading="lazy"
            data-testid="benefits-foto-bolsa"
          />
          <div className="p-8 md:p-10 text-center md:text-left">
            <h3 className="text-3xl font-bold mb-4" style={{ color: 'var(--sendhapy-yellow)' }}>
              SendHapy, tu marca de confianza
            </h3>
            <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.9)' }}>
              Compra en Estados Unidos y recibe tus paquetes en Costa Rica con un equipo que cuida cada envío.
            </p>
            <button
              onClick={() => scrollToSection('casillero')}
              className="btn-sendhapy-primary"
              data-testid="benefits-empezar-btn"
            >
              Empezar Ahora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
